import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export function formatCurrency(amountCents: number): string {
  return new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL'
  }).format(amountCents / 100)
}

/**
 * Masks an email address by replacing part of the local part with asterisks
 * @param email - The email address to mask
 * @returns The masked email address
 */
export function maskEmail(email: string): string {
  if (!email || !email.includes('@')) return email;
  
  const [localPart, domain] = email.split('@');
  if (localPart.length <= 2) return email;
  
  const maskedLocal = localPart.charAt(0) + localPart.charAt(1) + '*'.repeat(Math.max(localPart.length - 2, 0));
  return `${maskedLocal}@${domain}`;
}

/**
 * Formats hours in decimal to "+HH:MM" or "-HH:MM" format
 * @param hours - The hours in decimal format (e.g., 2.5 = 2h 30m)
 * @returns Formatted string like "+02:30" or "-01:15"
 */
export function formatHoursBalance(hours: number): string {
  const sign = hours >= 0 ? '+' : '-';
  const absHours = Math.abs(hours);
  const wholeHours = Math.floor(absHours);
  const minutes = Math.round((absHours - wholeHours) * 60);
  
  return `${sign}${String(wholeHours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}`;
}
